module.exports = __webpack_public_path__ + "img/lestream.4ed50c40.png";